require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-ifc-must-release-the-results-of-its-accountability.json") })
        }
      }, "path---en-us-update-ifc-must-release-the-results-of-its-accountability");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-ifc-must-release-the-results-of-its-accountability!./.cache/json/en-us-update-ifc-must-release-the-results-of-its-accountability.json
// module id = 754
// module chunks = 231608221292675